"use strict";
var appn;
(function (appn) {
    let IDTSortDir;
    (function (IDTSortDir) {
        IDTSortDir["asc"] = "asc";
        IDTSortDir["desc"] = "desc";
    })(IDTSortDir = appn.IDTSortDir || (appn.IDTSortDir = {}));
    let IDTColumnType;
    (function (IDTColumnType) {
        IDTColumnType["string"] = "string";
        IDTColumnType["numeric"] = "numeric";
        IDTColumnType["date"] = "date";
        IDTColumnType["html"] = "html";
    })(IDTColumnType = appn.IDTColumnType || (appn.IDTColumnType = {}));
    let ButtonAction;
    (function (ButtonAction) {
        ButtonAction["StartBilling"] = "StartBilling";
        ButtonAction["UpdateBilling"] = "UpdateBilling";
        ButtonAction["ChangeCard"] = "ChangeCard";
        ButtonAction["ChargeCard"] = "ChargeCard";
        ButtonAction["CancelBilling"] = "CancelBilling";
        ButtonAction["ProcessPayment"] = "ProcessPayment";
        ButtonAction["PayNow"] = "PayNow";
        ButtonAction["CancelAddCreditCard"] = "CancelAddCreditCard";
        ButtonAction["ProceedAddCreditCard"] = "ProceedAddCreditCard";
        ButtonAction["Activate"] = "Activate";
        ButtonAction["AddConnector"] = "AddConnector";
        ButtonAction["AddFilter"] = "AddFilter";
        ButtonAction["Add"] = "Add";
        ButtonAction["AddNew"] = "AddNew";
        ButtonAction["Archive"] = "Archive";
        ButtonAction["Apply"] = "Apply";
        ButtonAction["Authorize"] = "Authorize";
        ButtonAction["Cancel"] = "Cancel";
        ButtonAction["Close"] = "Close";
        ButtonAction["Create"] = "Create";
        ButtonAction["Deactivate"] = "Deactivate";
        ButtonAction["Delete"] = "Delete";
        ButtonAction["DeleteAll"] = "DeleteAll";
        ButtonAction["Disconnect"] = "Disconnect";
        ButtonAction["DownloadFile"] = "DownloadFile";
        ButtonAction["Edit"] = "Edit";
        ButtonAction["Export"] = "Export";
        ButtonAction["FilterOptions"] = "FilterOptions";
        ButtonAction["Go"] = "Go";
        ButtonAction["Import"] = "Import";
        ButtonAction["ImportUsers"] = "ImportUsers";
        ButtonAction["Install"] = "Install";
        ButtonAction["Invoice"] = "Invoice";
        ButtonAction["Lock"] = "Lock";
        ButtonAction["Manage"] = "Manage";
        ButtonAction["ManageInstalls"] = "ManageInstalls";
        ButtonAction["ManageTesting"] = "ManageTesting";
        ButtonAction["Move"] = "Move";
        ButtonAction["NewVersion"] = "NewVersion";
        ButtonAction["Organise"] = "Organise";
        ButtonAction["Print"] = "Print";
        ButtonAction["Publish"] = "Publish";
        ButtonAction["Reactivate"] = "Reactivate";
        ButtonAction["Remove"] = "Remove";
        ButtonAction["ResetPassword"] = "ResetPassword";
        ButtonAction["Retire"] = "Retire";
        ButtonAction["Revoke"] = "Revoke";
        ButtonAction["Save"] = "Save";
        ButtonAction["Search"] = "Search";
        ButtonAction["Send"] = "Send";
        ButtonAction["SendInvite"] = "SendInvite";
        ButtonAction["SignIn"] = "SignIn";
        ButtonAction["StartTesting"] = "StartTesting";
        ButtonAction["StopTesting"] = "StopTesting";
        ButtonAction["SubmitForReview"] = "SubmitForReview";
        ButtonAction["TestScreen"] = "TestScreen";
        ButtonAction["Unlock"] = "Unlock";
        ButtonAction["UpdateTesting"] = "UpdateTesting";
        ButtonAction["Checklist"] = "Checklist";
        ButtonAction["Back"] = "Back";
        ButtonAction["Package"] = "Package";
        ButtonAction["CreateConnector"] = "CreateConnector";
        ButtonAction["WebFormUrl"] = "WebFormUrl";
    })(ButtonAction = appn.ButtonAction || (appn.ButtonAction = {}));
})(appn || (appn = {}));
